<template>
  <div v-if="visible">
    <v-dialog v-model="showDialogue" persistent max-width="800">

      <v-card>
        <v-tabs v-model="tab" slider-color="grey" centered>
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-action">Action</v-tab>
          <v-tab href="#tab-info">Alert Info</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">

          <v-tab-item :value="'tab-action'">
            <v-card class="pt-2">

              <ethoca-action v-if="info.sourceTblId == 1"
                :visible="showActionPanel"
                :info="info"
                @show="changeDialog($event)"
              ></ethoca-action>

              <verifi-action v-if="info.sourceTblId == 2"
                :visible="showActionPanel"
                :info="info"
                @show="changeDialog($event)"
              ></verifi-action>
              
              <v-divider></v-divider>

            </v-card>
          </v-tab-item>
          
          <v-tab-item :value="'tab-info'">
            <v-card class="pt-2">

              <div v-for="field in infoFields" :key="field.value">
                <v-card-text class="py-0">
                  <span class="font-weight-bold pr-5 json-key-title">
                    {{ field.text }}:
                  </span>
                  {{ getInfoValue(field.value) }}
                </v-card-text>
              </div>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="changeDialog({showBool: false})">Close</v-btn>
              </v-card-actions>

            </v-card>
          </v-tab-item>

        </v-tabs-items>
      </v-card>
      
    </v-dialog> 
  </div>
</template>

<script>
import EthocaAction from './EthocaAction.vue';
import VerifiAction from './VerifiAction.vue';

export default {
  components: { EthocaAction, VerifiAction },
  props: {
    visible: Boolean,
    state: Boolean,
    info: Object
  },
  computed: {
    showDialogue() {
        return this.visible ? true : false;
    },
  },
  data() {
    return {
      infoFields: [
        { text: 'Post Date', value: 'processingTime'},
        { text: 'Source', value: 'sourceTblId'},
        { text: 'Alert Id', value: 'alertId'},
        { text: 'Type', value: 'type'},
        { text: 'Bin', value: 'bin'},
        { text: 'Last 4', value: 'last4Digits'},
        { text: 'ARN', value: 'arn'},
        { text: 'Amount', value: 'amount'},
        { text: 'Currency', value: 'currency'},
        { text: 'Auth Code', value: 'authCode'},
        { text: 'tnxId', value: 'tnxId'},
        { text: 'Billing Narrative', value: 'billingNarrative'},
        { text: 'insTs', value: 'insTs'},
        { text: 'daId', value: 'daId'},
        { text: 'UUID', value: 'uuid'},
        { text: 'Merchant Id', value: 'merchantUuid'},
        { text: 'Alert Status', value: 'state'}
      ],          
      tab: null,
    }
  },
  methods: {
    getInfoValue(field) {
      return this.info[field];
    },
    changeDialog(args) {
      // console.log("changeDialogue:", showBool);
        // this.resetForm();
        this.$emit('close', args);
    },
  }
}
</script>

<style>
    .json-key-title {
        display: inline-flex;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    /* Hint colour */
    .v-messages__message {
      color: red;
    }
</style>